
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.787 0A1.8 1.8 0 000 1.791v10.857c0 .98.808 1.785 1.783 1.791l1.799.012.006 2.885a.666.666 0 001.064.531l4.565-3.408 6.998-.02A1.802 1.802 0 0018 12.65V1.79A1.8 1.8 0 0016.213 0H1.787zm0 1.332h14.426c.262 0 .455.193.455.459v10.857a.444.444 0 01-.457.46l-7.219.019a.666.666 0 00-.396.133l-3.678 2.746-.004-2.219a.666.666 0 00-.664-.664l-2.459-.016a.444.444 0 01-.459-.459V1.791c0-.266.193-.459.455-.459z","font-family":"sans-serif","overflow":"visible","paint-order":"markers stroke fill"}}),_c('path',{attrs:{"d":"M5.463 4.781a.66.66 0 00-.66.66.66.66 0 00.66.66h7.049a.66.66 0 00.66-.66.66.66 0 00-.66-.66h-7.05zm4.557 3.555l-4.565.025a.66.66 0 00-.656.666.66.66 0 00.664.657l4.564-.026a.66.66 0 00.657-.666.66.66 0 00-.664-.656z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    